<script setup lang="ts">
import { legalCompany as c, legalHost as h } from '~/content/legal'
</script>

<template>
    <LegalPage title="Mentions légales"
        description="Mentions légales du site Deboosere Chauffage Sanitaire : éditeur, hébergeur, propriété intellectuelle.">
        <p>
            Conformément aux articles 6-III et 19 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans
            l’économie numérique (LCEN), les informations suivantes sont portées à la connaissance des utilisateurs
            du site.
        </p>

        <h2>1. Éditeur du site</h2>
        <div class="legal-box">
            <p><strong>{{ c.name }}</strong> ({{ c.tradeName }})</p>
            <ul>
                <li>Forme juridique : {{ c.legalForm }}</li>
                <li>Siège social : {{ c.address }}</li>
                <li>SIRET : {{ c.siret }}</li>
                <li>Immatriculation : {{ c.rcs }}</li>
                <li>N° TVA intracommunautaire : {{ c.vat }}</li>
                <li>Code NAF : {{ c.naf }}</li>
                <li>Téléphone : <a :href="c.phoneHref">{{ c.phone }}</a></li>
            </ul>
            <p class="!mb-0">Directeur de la publication : {{ c.director }}</p>
        </div>

        <h2>2. Activité réglementée</h2>
        <p>
            {{ c.rge }} L’entreprise exerce une activité artisanale de plomberie, chauffage et sanitaire.
        </p>

        <h2>3. Hébergement</h2>
        <p>
            Le site est hébergé par <strong>{{ h.name }}</strong>, {{ h.address }} —
            <a :href="h.website" target="_blank" rel="noopener">{{ h.website }}</a>.
        </p>

        <h2>4. Conception et réalisation</h2>
        <p>
            Site conçu et développé par
            <a href="https://astrocom.fr/" target="_blank" rel="noopener">Astrocom</a>.
        </p>

        <h2>5. Propriété intellectuelle</h2>
        <p>
            L’ensemble des éléments du site (textes, photographies, vidéos, logo, charte graphique, structure) est la
            propriété exclusive de {{ c.name }} ou fait l’objet d’une autorisation d’utilisation. Toute reproduction,
            représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable est
            interdite et constitue une contrefaçon sanctionnée par les articles L335-2 et suivants du Code de la
            propriété intellectuelle.
        </p>
        <p>
            Les marques et logos des fabricants présentés sur le site (Atlantic, Daikin, De Dietrich, Vaillant,
            Viessmann, etc.) sont la propriété de leurs titulaires respectifs et sont cités uniquement pour indiquer
            les équipements sur lesquels l’entreprise intervient.
        </p>
        <p>
            Les avis clients affichés proviennent de la fiche Google de l’entreprise et restent la propriété de leurs
            auteurs.
        </p>

        <h2>6. Données personnelles et cookies</h2>
        <p>
            Le traitement de vos données personnelles est décrit dans notre
            <NuxtLink to="/politique-de-confidentialite">politique de confidentialité</NuxtLink>. L’usage des cookies
            est détaillé dans notre <NuxtLink to="/cookies">politique de cookies</NuxtLink>.
        </p>

        <h2>7. Médiation de la consommation</h2>
        <p>
            Conformément aux articles L612-1 et suivants du Code de la consommation, en cas de litige non résolu
            après réclamation écrite auprès de l’entreprise, le consommateur peut recourir gratuitement au médiateur
            de la consommation. Les conditions sont précisées dans nos
            <NuxtLink to="/cgv">conditions générales de vente</NuxtLink>.
        </p>

        <h2>8. Droit applicable</h2>
        <p>
            Les présentes mentions légales sont régies par le droit français. L’utilisation du site est encadrée par
            nos <NuxtLink to="/cgu">conditions générales d’utilisation</NuxtLink>.
        </p>
    </LegalPage>
</template>
